import React, { useEffect, useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';
import { useInView } from 'react-intersection-observer';
import '../styles/ProjectItem.css'

const ProjectItem = ({position,sideStageClass,itemStageClass,to,title,description,direction,img,id})=>{
    
    const [type,setType] = useState(false)
    const [isInView,setView] = useState(false)
    const {ref,inView,entry} = useInView({threshold:0})
    const projectItem = isInView ? "project-item" : "initial"
    const position_coords = document.getElementById(position)?.getBoundingClientRect().top
    console.log(position+':'+position_coords)
    useEffect(()=>{
        
        setView(inView)
    })
    const typeTrigger = ()=>{
        setType(true)
    }
return(
    <>
   <a  href={to} id={id?id:''} target='_blank' ref={ref} className={projectItem}>
    <svg   className={sideStageClass} width="277" height="115" viewBox="0 0 277 115" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 60.5H272" stroke="#0066FF"/>

<circle cx="244" cy="3" r="3" fill="#0066FF"/>
<circle cx="274" cy="61" r="3" fill="#0066FF"/>
<circle cx="104" cy="52" r="3" stroke="#0066FF"/>
<circle cx="252.5" cy="80" r="3" stroke="#0066FF"/>
<circle cx="114.5" cy="69" r="3" stroke="#0066FF"/>
<circle cx="259.5" cy="52" r="3" fill="#0066FF"/>
<circle cx="230.5" cy="91" r="3" fill="#0066FF"/>
<circle cx="263" cy="103" r="3" fill="#0066FF"/>
<circle cx="254.5" cy="27" r="3" fill="#0066FF"/>

<path d="M77.5 60.5L104 26.5H252" stroke="#0066FF"/>
<path d="M128.5 26.5L146.5 3H241.5" stroke="#0066FF"/>
<path d="M89 60.5L120 90.5H228" stroke="#0066FF"/>
<path d="M171.5 90.5L195.5 114H228L237 102.5H260.5" stroke="#0066FF"/>
<path d="M105 49.5L114.5 36H204L225.5 51.5H257" stroke="#0066FF"/>
<path d="M118 69H149L170 79.5H249.5" stroke="#0066FF"/>
</svg>


<div onAnimationEnd={typeTrigger}  className={itemStageClass}>

    <div  className='itemOverlay'>
    <div className='infos-container'>
        <div className='project-title'>
            {type && <Typewriter words={[title]} loop={1} typeSpeed={20} />}
        </div>
        <div className='project-description'>
        {type && <Typewriter words={[description]} loop={1} cursor typeSpeed={40} />        }
        </div>
        </div>
    </div>
    
 <div className='backgroundImg' style={{backgroundImage:`url(${img})`}}>

 </div>
</div>
</a>
    </>
)
}
export default ProjectItem;